import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GameProvider } from './contexts/GameContext';
import { AudioProvider } from './contexts/AudioContext';
import Home from './pages/Home';
import Instructions from './pages/Instructions';
import HoneyInfo from './pages/HoneyInfo';
import GameScreen from './pages/GameScreen';
import Results from './pages/Results';
import Admin from './pages/Admin';
import AudioControls from './components/AudioControls';
import './styles/App.css';

function App() {
  return (
    <AudioProvider>
      <GameProvider>
        <Router>
          <div className="app">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/instructions" element={<Instructions />} />
              <Route path="/honey-info" element={<HoneyInfo />} />
              <Route path="/game" element={<GameScreen />} />
              <Route path="/results" element={<Results />} />
              <Route path="/admin-config" element={<Admin />} />
            </Routes>
            <AudioControls />
          </div>
        </Router>
      </GameProvider>
    </AudioProvider>
  );
}

export default App;
